module.exports = __webpack_public_path__ + "img/bema_logo.943c4f7c.png";